// 麻雀ソリティア**固有**の設定（localStorage 永続）。
//
// ポータル横断の設定（音量・ミュート・BGM・言語）は
// [platform/net/settings.ts](@/platform/net/settings) が持つ。ここにあるのは
// 「このゲームでしか意味を持たない」項目だけ。所属の決め方は CLAUDE.md の
// 「設定は所属で2つに分かれる」を参照。
//
// キーは `mahjong.*`（＝`game_key` と同じ文字列）。データ削除が接頭辞で掃くので、
// ここに増やしたぶんは自動で消える対象になる。
import type { GameSettingsSlice } from '@/platform/net/settings';
import { GAME_KEY } from '../gameKey';

const K_HINT = `${GAME_KEY}.hintOn`;

export const GAME_SETTINGS_DEFAULTS = {
  /** 取れる牌を淡く示す。 */
  hintOn: true,
} as const;

/**
 * 取れる牌の目印（既定 ON）。
 *
 * 🔴 **既定を ON にするのは親切のためではない**。上海は「上に何も乗っていない かつ
 *   左右どちらかが空いている」という**見た目からは読み取りにくい条件**で取れる牌が決まる。
 *   ⚠️ 目印が無いと、覚えるまでは**押しても反応しない牌を延々と押す**ことになり、
 *   本人には「反応が悪いゲーム」としか見えない（規則を疑う理由が生まれない）。
 *   ⇒ 消せるようにはするが、**既定では出す**。💡 さめがめ・カラーソートと同じ判断。
 */
export function isHintOn(): boolean {
  const v = localStorage.getItem(K_HINT);
  return v === null ? GAME_SETTINGS_DEFAULTS.hintOn : v === '1';
}

export function setHintOn(on: boolean): void {
  localStorage.setItem(K_HINT, on ? '1' : '0');
}

/** このゲームの設定を既定値へ戻す。 */
export function resetGameSettings(): void {
  setHintOn(GAME_SETTINGS_DEFAULTS.hintOn);
}

/**
 * サーバー同期用のスライス。`registry.ts` に載せると
 * `/api/settings` の `games.<gameKey>` として自動で往復するようになる。
 */
export const mahjongSettingsSlice: GameSettingsSlice = {
  gameKey: GAME_KEY,
  read: () => ({ hintOn: isHintOn() }),
  apply: (s) => {
    if (typeof s.hintOn === 'boolean') setHintOn(s.hintOn);
  },
  reset: resetGameSettings,
};
